import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "@aihub/core/authorization";
import { MainNewComponent } from "projects/shared-new/src/lib/components-new/main-new/main-new.component";

const routes: Routes = [
  { path: "home", canActivate: [AuthGuard], component: MainNewComponent },
  { path: "profile", canActivate: [AuthGuard], component: MainNewComponent },
  { path: "post", canActivate: [AuthGuard], component: MainNewComponent },
  {
    path: "**",
    redirectTo: "home" + "?" + window.location.href.split("?")[1] || undefined,
    pathMatch: "full",
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
